/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBranchOfficeDto } from '../../models/customer-branch-office-dto';
import { CustomerBranchOfficeFormDto } from '../../models/customer-branch-office-form-dto';

export interface UpdateCustomerBranchOffice$Params {

/**
 * customer id
 */
  customerId: number;

/**
 * branch office id
 */
  branchOfficeId: number;
      body: CustomerBranchOfficeFormDto
}

export function updateCustomerBranchOffice(http: HttpClient, rootUrl: string, params: UpdateCustomerBranchOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBranchOfficeDto>> {
  const rb = new RequestBuilder(rootUrl, updateCustomerBranchOffice.PATH, 'put');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('branchOfficeId', params.branchOfficeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBranchOfficeDto>;
    })
  );
}

updateCustomerBranchOffice.PATH = '/customers/{customerId}/branch-offices/{branchOfficeId}';
